module.exports = __webpack_public_path__ + "img/80s-radio.261b59b4.png";